import { EarlySettlementLeasing } from 'components/early-settlement-leasing/EarlySettlementLeasing';
import React from 'react';

export const EarlySettlementLeasingPage: React.FC = () => {
    return <EarlySettlementLeasing />;
};
